import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { useTranslation } from 'react-i18next';
import travelimg from '../../tr.png';
import { format } from 'date-fns';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
import { loadSanadBranding } from '../utils/loadSanadBranding';
const { config } = require('../../api/api');



function DownloadSanadAffordablePolicy() {

  const base_url = config.baseURL;
  const redirecturl = config.redirectURL;
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

  const { t } = useTranslation();
  const vendor_key = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';
  const api_headers = {
    'Authorization': 'Bearer ' + vendor_key,
    'Content-Type': 'application/json' // Ensure you're sending JSON
  }

  const [dhofarData, setDhofarData] = useState(null);
  const [policyNo, setPolicyNo] = useState(null);
  const [policyLink, setPolicyLink] = useState(null);
  const [policyDetails, setPolicyDetails] = useState(null);
  const [policyCoverDetails, setPolicyCoverDetails] = useState(null);
  const [sandaUrlData, setSandaUrlData] = useState(null);
  const [benData, benAppData] = useState(false);
  const redirect_url = "https://superjetom.com/";
  const [payment_link, setPaymentLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const [PolicyPaymentLink, setPolicyPaymentLink] = useState(null);
  const [AvailableDocuments, setAvailableDocuments] = useState(false);


  useEffect(async () => {
    
    const fetchData = async () => {
      try {
        var accessTokenData = await createAccessToken();
        var accessToken = accessTokenData?.result?.data?.token;
        if (accessToken != null && accessToken != undefined) {
          
          setDhofarData(accessToken);

        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    loadSanadBranding();
  }, []);

  useEffect(async () => {
    const urlSearchString = window.location.search;
    const uparams = new URLSearchParams(urlSearchString);
    const policy_no = uparams.get('policyno');
    setPolicyNo(policy_no);
    var policy_api_data = {
      "policy_no": policy_no
    };
    const response = await fetch(`${base_url}/get_sanad_medical_affordable_poliy_number`, {
      method: 'POST',
      headers: api_headers,
      body: JSON.stringify(policy_api_data),
    });

    const data = await response.json();

    if (data.message === 'success') {

      setPolicyDetails(data?.result[0]);

      var policy_cover_details = data?.result[0]?.policy_data;
      var policy_sanad_details = data?.result[0]?.sanad_data;
      var file = data?.result[0]?.file_upload;
      setFileupload(file);
      if (policy_cover_details) {
        policy_cover_details = JSON.parse(policy_cover_details);
        setPolicyCoverDetails(policy_cover_details);
      } else {
        setPolicyCoverDetails(null);
      }

      if (policy_sanad_details) {
        policy_sanad_details = JSON.parse(policy_sanad_details);
        var url_data = {
          'back_url': policy_sanad_details.sanad_BackUrl,
          'return_url': policy_sanad_details.sanad_ReturnUrl,
          'error_url': policy_sanad_details.sanad_ErrorUrl,
      };
      setSandaUrlData(url_data);
      }
      // Handle successful response
      // Example: setPaymentUrl(data.result.data.payment_url);
    } else {
      setPolicyDetails(null);
      setPolicyCoverDetails(null);
      // Handle failure
      // setPolicyLink('');
    }
    // var url_data = Cookies.get('sanadUrlData');
    // 
    // if (url_data) {
    //   setSandaUrlData(JSON.parse(url_data));
    // }


  }, []);
  const handledownload = async () => {
    var datas={
      'token':dhofarData,
      'policy_no':policyNo
    };
    
      if (vendor_key !== "") {
        setLoading(true);
        try {
          const response = await fetch(base_url + "/medical_documents", {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${vendor_key}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(datas),
            responseType: "blob", // Fetch response as a binary file
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          // Convert response to blob
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
    
          // Create a download link
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", policyNo+".pdf"); // Ensure correct file type
          document.body.appendChild(link);
          // link.click();
          window.open(url, "_blank");
          setLoading(false);
    
          // Cleanup
          // document.body.removeChild(link);
          // window.URL.revokeObjectURL(url);
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 60000); // 1 minute in milliseconds
    
        } catch (error) {
          setLoading(false);  
          console.error("Error generating quotation PDF:", error);
        }
      }
    };


  const createAccessToken = async () => {
    try {
      const response = await fetch(base_url + '/sanad_sjet_tcs_access_token', {
        method: 'GET',
        headers: api_headers
      });
      const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
      if (data.message === 'success') {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };


//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         
//         const postData = { token: dhofarData, policy_no: policyNo };

//         // const postData = { id: someId }; // Adjust as necessary
//         const response = await fetch(base_url + '/get_sanad_medical_affordable_policydocument', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(postData),
//         });
// 
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         const data = await response.json();
//         if (data.message === 'success' && data?.result?.data?.policy_schedule_url != null) {
//           setPolicyLink(data.result.data.policy_schedule_url);
//         } else {
//           setPolicyLink('');
//         }
//       } catch (error) {
//         console.error('Error fetching policy documents:', error);
//       }
//     };
//     fetchData();
//   }, [dhofarData, policyNo]);

useEffect(() => {
    const fetchPolicyDocument = async () => {
        
      if (!dhofarData || !policyNo) return; // Ensure both values are available before making the API call

      try {
        const postData = { token: dhofarData, policy_no: policyNo };

        const response = await fetch(base_url + '/get_sanad_medical_affordable_policydocument', {
          method: 'POST',
          headers:api_headers,
          body: JSON.stringify(postData),
        });

        if (!response.ok) {
          setPolicyLink('');
          // throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setAvailableDocuments(data?.result?.success);
        if (data.message === 'success' && data?.result?.data?.payment_receipt_url) {
          setPolicyLink(data.result.data.payment_receipt_url);
        } else {
          setPolicyLink('');
        }
      } catch (error) {
        console.error('Error fetching policy documents:', error);
      }
    };

    fetchPolicyDocument();
  }, [dhofarData, policyNo]);


        const [passportFile, setPassportFile] = useState(null);
       
        const [showUploadModal, setShowUploadModal] = useState(false);
        const [passportFileError, setPassportFileError] = useState('');
        const [sponsorFileError, setsponsorFileError] = useState('');
        const [sponsoridFile, setsponsoridFile] = useState(null);
        const [fileupload, setFileupload] = useState(null);
        const handleUpload = async (e) => {

          // ;
          e.preventDefault();
          setsponsorFileError('');
          setPassportFileError('');
          const dhofar = dhofarData;
          const policy = policyNo;
          const formData = new FormData();
          formData.append('token', dhofar);
          formData.append('policy_no', policy);
          
          if(passportFile == null){
            setPassportFileError('Please select Passport file ');
          }
          else if(sponsoridFile == null){
            setsponsorFileError('Please select sponsor resident ID file ');
          }
          else{
            setLoading(true);
            if (passportFile !== null) {
              formData.append('passport', passportFile);
            }
        
            if (sponsoridFile !== null) {
              formData.append('sponsor_id', sponsoridFile);
            }
        
            const response = await fetch(base_url + '/get_sanad_medical_affordable_uploadfiles', {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${vendor_key}`
              },
              body: formData
            });
            const data = await response.json();
            setLoading(false);
            if (data.result.success) {
              // var file = await policyDetailsDB();
              setFileupload('yes');
              setPassportFile(null);
              alert(data.result.message);
              handleClose();
            } else {
              alert('file is not uploaded try again');
              handleClose();
            }
      
          }
      
         
        };
      
        const handleFileChange = (e) => {
          // ;
          if (e.target.files.length === 1) {
            const file = e.target.files[0];
            const name = e.target.name;
            const fileType = file.type;
            const maxSize = 2 * 1024 * 1024; // 5MB in bytes
      
            // Check if the file exceeds the size limit
            if (file && file.size > maxSize) {
              alert('File size exceeds the 2MB limit.');
              return;
            }
      
            if (fileType === 'application/pdf') {
              if (name === 'passport' && passportFile == null) {
                setPassportFile(file);
              } else if (name === 'passport' && passportFile !== null && passportFile !== '' && passportFile !== undefined) {
                setPassportFile(null);
                setPassportFile(() => file);
              } else if (name === 'sponsorid' && sponsoridFile == null) {
                setsponsoridFile(file);
              } else if (name === 'sponsorid' && sponsoridFile !== null && sponsoridFile !== '' && sponsoridFile !== undefined) {
                setsponsoridFile(null);
                setsponsoridFile(() => file);
              }
            } else {
              alert('Please select a valid PDF file.');
            }
            document.getElementById('passport').value = '';
            document.getElementById('sponsorid').value = '';
          }
        };
        const handleFileDelete = (e) => {
          // ;
          const name = e.target.getAttribute('data-name');
          if (name === 'sponsorid') {
            setsponsoridFile(null);
            document.getElementById('sponsorid').value = '';
          } else if (name === 'passport') {
            setPassportFile(null);
            document.getElementById('passport').value = '';
          }
        };
      
        const handleClose = () => {
          setShowUploadModal(false);
        };
      
        const handleShow = () => {
          setShowUploadModal(true);
        };
  const createPolicyPaymentLink = async (accessToken, policy_no) => {
    try {
          setLoading(true);
            var policy_data =
            {
                "token": accessToken,
                "policy_no": policy_no,
                "redirect_url":  redirecturl+"/sanad-medical-downloadpolicy?policyno="+policy_no
               
                
            }
            
            const response = await fetch(base_url + '/get_sanad_medical_affordable_paymentlink', {
                method: 'POST',
                headers: api_headers,
                body: JSON.stringify(policy_data)
            });
              setLoading(false);
            const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
      if (data.message === 'success') {
              window.location.href = data?.result?.data?.payment_url;
                // setPersonalPolicyPaymentLink(data?.result?.data.payment_url);
                // setCountryList(data.result.data);
                // setRelationList(data?.result?.data);
            } else {
                // setPersonalPolicyPaymentLink(null);
            }
    } catch (error) {
         setLoading(false);
            // setPersonalPolicyPaymentLink(null);
            // return null;
        }
    };

  return (
    policyNo?<Fragment>
      <div className="features_section layout_padding my-1">
        <div>
          <div className="row ml-md-0 mx-2">
            <Col md={3}></Col>
            <Col md={6} className="myforms my-3 ">
              {/* <div style={{ display: 'flex', paddingBottom: '20px' }}>
                <button 
                style={{ width: '100px', fontWeight: 'bold' }} onClick={() => {
                  const regex = /^(ftp|http|https):\/\/[^ "]+$/;
                  var isValidUrl = regex.test(sandaUrlData?.back_url);

                  if (isValidUrl) {
                    window.location.href = sandaUrlData?.back_url + '?policyno=' + policyDetails?.policy_no;
                    // window.open(sandaUrlData?.back_url + '?policyno=' + policyDetails?.policy_no, '_blank')
                  } else {
                    window.location.reload();
                  }

                }} >Back</button>
              </div> */}

              <div style={{ textAlign: 'left', fontSize: '20px' }}>
                <b>Policy Details  - {policyDetails != null ? policyDetails?.policy_no : ''}</b>
              </div>

              <br />

              <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>

                <tbody>

                  <tr><td style={{ width: '50%' }}><b>Name</b>
                  </td><td>{policyDetails != null ? policyDetails?.first_name : ''}</td></tr>

                  <tr><td><b>Occupation</b>
                  </td><td>{policyCoverDetails != null ? policyCoverDetails?.personalInformation?.occupation?.toString() : ''}</td></tr>


                  <tr><td><b>Passport</b>
                  </td><td>{policyDetails != null ? policyDetails?.sanad_passport_no : ''}</td></tr>

                  <tr><td><b>Sanad Reference No</b>
                  </td><td>{policyDetails != null ? policyDetails?.sanad_reference_no : ''}</td></tr>

                  <tr><td><b>Civil ID</b>
                  </td><td>{policyCoverDetails != null ? policyCoverDetails?.civil_id : ''}</td></tr>

                  <tr><td><b>Total Fee (OMR)</b>
                  </td><td>{policyCoverDetails != null ? policyCoverDetails?.amount?.total?.toString() : ''}</td></tr>

                  <tr><td><b>Created</b>
                  </td><td>{policyDetails != null ? policyDetails?.created_at.toString().split('T')[0] : ''}</td></tr>

                </tbody>

              </table>
              <div className="text-center">
                {
                 AvailableDocuments && AvailableDocuments != null && AvailableDocuments != '' ?
                    // true ?
                  
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    { fileupload !='yes'&&
                    // ?  <button
                    //     onClick={() => {
                    //       
                    //       handledownload();
                    //       // if (policyLink) {
                    //       //   var url = policyLink;
                    //       //   const link = document.createElement('a');
                    //       //   link.href = url;
                    //       //   link.target = '_blank';
                    //       //   link.download = url.split('/').pop(); // Extracts filename from URL
                    //       //   document.body.appendChild(link);
                    //       //   link.click();
                    //       //   document.body.removeChild(link);
                    //       // } else {
                    //       //   alert('Policy error')
                    //       // }
                    //     }}
                    //     style={{ fontWeight: 'bold' }}
                    //   >
                    //     Download Policy Document
                    //   </button>:
                      <button
                  
                                      onClick={handleShow}
                                      style={{ fontWeight: 'bold' }}
                                    >
                                      Upload Files
                                    </button>}

                      <div style={{ margin: '10px 0' }} >
                      {fileupload =='yes'&&
                        <button style={{ marginLeft: 'auto', fontWeight: 'bold' }}
                          onClick={() => {
                            
                            const regex = /^(ftp|http|https):\/\/[^ "]+$/;
                            var isValidUrl = regex.test(sandaUrlData?.return_url);

                            if (isValidUrl) {
                              window.location.href =
                                sandaUrlData?.return_url +
                                '?policyno=' + policyDetails?.policy_no +
                                '&sanad_reference_no=' + policyDetails?.sanad_reference_no +
                                '&policy_link=' + policyLink;
                              // window.open(sandaUrlData?.return_url+ '?policyno=' + policyDetails?.policy_no+'&sanad_reference_no='+policyDetails?.sanad_reference_no+'&policy_link='+policyLink, '_blank')
                            } else {
                              window.location.reload();
                            }

                          }}
                        >Go To Sanad</button>}
                      </div>
                      </div>

                    : !AvailableDocuments ? <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><h2>Policy Payment Pending</h2>
                      <div>
                        <button
                          onClick={() => {
                            createPolicyPaymentLink(dhofarData, policyNo);

                            // if (policyDetails?.payment_link) {
                            //   window.location.href = policyDetails?.payment_link;

                            //   // Reload the current page (form tab)
                            //   // window.location.reload();
                            // }

                          }} style={{ marginLeft: 'auto', width: '200px', fontWeight: 'bold' }}>Make Payment</button></div></div> : "Loading"
                }
              </div>
              <p></p>
             {/* {!policyLink &&(<p style={{ color: "red" }}>(This payment link is valid for a maximum of 24 hours. If the link expires, please create a new policy.\nرابط الدفع هذا صالح لمدة أقصاها 24 ساعة. إذا انتهت صلاحية الرابط، يرجى إنشاء سياسة جديدة.) </p>)} */}
             {!AvailableDocuments&&( <label style={{ color: "red" ,display: "flex", justifyContent: "space-between", alignItems: "center" }}>
             <span>
             This payment link is valid for a maximum of 24 hours. If the link expires, please create a new policy.
             </span>
             <span style={{ textAlign: "right", direction: "rtl" }}>
             رابط الدفع هذا صالح لمدة أقصاها 24 ساعة. إذا انتهت صلاحية الرابط، يرجى إنشاء سياسة جديدة.
             </span>
         </label>)}
          </Col>
            <Col md={3}></Col>
            
          </div>
        </div>
      </div>
      {showUploadModal && (
                        <div className="modal fade show" style={{ display: 'block' }} id="uploadModal">
                          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ left: '10%' }}>
                            <div className="modal-content">
                              <div className="modal-header">
                                <h2 className="modal-title">
                                  <span>
                                    {t('Upload')} {t('Documents')}
                                  </span>
                                  <p style={{color:'red',marginLeft:'25px'}}>
                                Please upload files in PDF format only.
                                </p>
                                </h2>
                                <button type="button" className="close" onClick={handleClose}>
                                  &times;
                                </button>
                              </div>
                              <div className="modal-body">
                                <form onSubmit={(e) => handleUpload(e)}>
                                  <div className="form-group row">
                                    <label className="col-sm-12 col-md-8 col-form-label text-left">
                                      <strong>{t('Passport copy with visa page or Resident ID')}</strong>
                                      {/* <br /> <small>{t('(With visa page or resident ID)')}</small> */}
                                    </label>
                                    <div className="col-sm-12 col-md-4">
                                      {passportFile === null ? (
                                        <button type="button" onClick={() => document.getElementById('passport').click()}>
                                          {t('Upload File')}
                                        </button>
                                      ) : (
                                        <div className="d-flex border mt-2 align-items-center p-2 rounded">
                                          <p className="mb-0" style={{ width: '80%' }}>
                                            {passportFile.name.length > 5
                                              ? `${passportFile.name.substring(0, 5)}...${passportFile.type.split('/')[1]}`
                                              : passportFile.name}
                                          </p>
                                          <span
                                            className="text-danger ms-auto"
                                            onClick={handleFileDelete}
                                            data-name="passport"
                                            style={{ cursor: 'pointer', width: '20%' }}>
                                            &times;
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {passportFileError && <p style={{ color: 'red' }}>{passportFileError}</p>} {/* Show error message */}
                
                                  <div className="form-group row mt-3">
                                    <label className="col-sm-12 col-md-8 col-form-label text-left">
                                      <strong>{t('Sponsor resident ID or passport with visa page')}</strong>
                                    </label>
                                    <div className="col-sm-12 col-md-4">
                                      {sponsoridFile === null ? (
                                        <button type='button' onClick={() => document.getElementById('sponsorid').click()}>
                                          {t('Upload File')}
                                        </button>
                                      ) : (
                                        <div className="d-flex border mt-2 align-items-center p-2 rounded">
                                          <p className="mb-0" style={{ width: '80%' }}>
                                            {sponsoridFile.name.length > 5
                                              ? `${sponsoridFile.name.substring(0, 5)}...${sponsoridFile.type.split('/')[1]}`
                                              : sponsoridFile.name}
                                          </p>
                                          <span
                                            className="text-danger ms-auto"
                                            onClick={handleFileDelete}
                                            data-name="sponsorid"
                                            style={{ cursor: 'pointer', width: '20%' }}>
                                            &times;
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {sponsorFileError && <p style={{ color: 'red' }}>{sponsorFileError}</p>}
                                  <input
                                    type="file"
                                    name="passport"
                                    id="passport"
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                  />
                                    <input
                                    type="file"
                                    name="sponsorid"
                                    id="sponsorid"
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                  />
                                  
                
                                  <div className="mt-4 text-center">
                                    <button type="submit" >
                                      {t('  Submit File ')}
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>: <div style={{
           
            border: 'none',
            textAlign: 'center',
            marginTop: '25%',
            fontSize: '20px',
            fontWeight: 'bold'
        }}>  { "Policy Number Invalid"}</div>
  );
}

export default DownloadSanadAffordablePolicy;